import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
import { sha256 } from 'js-sha256';
import { ServerConstantsService } from './serverConstants.service';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      //this.loginService.loader = true;
    
      let authHeader={personId:null,timeStamp:Date.now()}
      if(ServerConstantsService.serverConstants !== undefined && request.url !== 'https://worldtimeapi.org/api/timezone/America/Chicago'){
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        authHeader.personId = (sessionStorage.getItem('id') !== undefined && sessionStorage.getItem('id') !== null) ? parseInt(CryptoJS.AES.decrypt(sessionStorage.getItem('id'), key).toString(CryptoJS.enc.Utf8)) : null;
        let encrypted = CryptoJS.AES.encrypt(JSON.stringify(authHeader), key);
        request = request.clone({
          setHeaders: {
            Authorization: encrypted.toString()
          } 
        });
      }
      
    /*if(this.loginService.serverConst == undefined){
        this.load();
    }*/
    $(".loader").removeClass('hide');
    return next.handle(request).do((event: HttpEvent<any>) => {
        setTimeout(()=>{
            $(".loader").addClass('hide');
        },1000)
        
        if (event instanceof HttpResponse) {
          // do stuff with response if you want
          //this.loginService.loader = false;
        }
      }, (err: any) => {
        setTimeout(()=>{
            $(".loader").addClass('hide');
        },1000)
        if (err instanceof HttpErrorResponse) {
            //this.loginService.loader = false;
          if (err.status === 401) {
            // redirect to the login route
            // or show a modal
          }
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/interceptor.ts